(function () {
  var root = document.getElementById('notb-conv');
  if (!root) return;
  var L = root.getAttribute('data-lang') === 'en' ? 'en' : 'nl';
  var T = {
    nl: { ready: 'Klaar om om te zetten', decode: 'Openen...', work: 'Bewerken...', enc: 'Omzetten...', done: 'Klaar', bad: 'Kan dit bestand niet openen', big: 'Te groot (max. 150 MB)', go: 'Omzetten', gon: 'Omzetten ({n} bestanden)', zip: 'ZIP maken...', badcode: 'Deze code klopt niet.', unlocked: 'Pro staat aan. Veel plezier!', lufs: 'Loudness: {a} naar {b} LUFS', saved: 'Gedownload' },
    en: { ready: 'Ready to convert', decode: 'Opening...', work: 'Processing...', enc: 'Converting...', done: 'Done', bad: "Can't open this file", big: 'Too large (max 150 MB)', go: 'Convert', gon: 'Convert ({n} files)', zip: 'Creating ZIP...', badcode: "That code doesn't work.", unlocked: 'Pro is on. Have fun!', lufs: 'Loudness: {a} to {b} LUFS', saved: 'Downloaded' }
  }[L];
  var PRO_HASH = ['cf7de76534eed8a83fbd695c119854ab9840f3c585efa90333b44160012d3a80', '4227a4a75dcad45a5ae01a75d02e291861161bdeb992349cacc3d5e2b82fe0f1'];
  var SALT = 'notb-cv|', KEY = 'notb_cv_pro';
  var LAME = 'https://cdnjs.cloudflare.com/ajax/libs/lamejs/1.2.1/lame.min.js';
  var hide = document.createElement('style'); hide.textContent = 'shopify-chat{display:none!important}'; document.head.appendChild(hide);

  var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return root.querySelectorAll(s); };
  var drop = $('[data-cv-drop]'), fileIn = $('[data-cv-file]'), list = $('[data-cv-list]'), panel = $('[data-cv-panel]'), goBtn = $('[data-cv-go]'), status = $('[data-cv-status]');
  var proBox = $('[data-cv-probox]'), proMsg = $('[data-cv-promsg]'), codeIn = $('[data-cv-code]'), skipBtn = $('[data-cv-skip]');
  var files = [], fmt = 'mp3', q = { mp3: '320', wav: '16', flac: '16' }, rate = 44100, ex = { loud: false, trim: false, tags: false }, cover = null, busy = false, pro = false;

  // ------------------------------------------------------------ pro
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function sha(s) {
    if (!window.crypto || !crypto.subtle) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(s)).then(function (b) { return Array.prototype.map.call(new Uint8Array(b), function (x) { return ('0' + x.toString(16)).slice(-2); }).join(''); });
  }
  function tryCode(code, silent) {
    var norm = (code || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); if (!norm) return Promise.resolve(false);
    return sha(SALT + norm).then(function (h) {
      if (PRO_HASH.indexOf(h) > -1) { pro = true; store(KEY, h); proUi(); if (!silent) { proMsg.textContent = T.unlocked; setTimeout(closePro, 1200); } return true; }
      if (!silent) proMsg.textContent = T.badcode; return false;
    });
  }
  function proUi() { root.classList.toggle('is-pro', pro); $$('[data-cv-badge]').forEach(function (b) { b.hidden = !pro; }); }
  var saved = store(KEY); if (saved && PRO_HASH.indexOf(saved) > -1) pro = true;
  (function () {
    var m = location.search.match(/[?&]pro=([^&#]+)/);
    if (m) { tryCode(decodeURIComponent(m[1]), false).then(function (ok) { if (ok) openPro(true); }); try { history.replaceState(null, '', location.pathname + location.hash); } catch (e) {} }
  })();
  var after = null;
  function openPro(okOnly, then, skip) {
    after = then || null; proBox.hidden = false; proMsg.textContent = okOnly ? T.unlocked : '';
    skipBtn.hidden = !skip; skipBtn.onclick = skip ? function () { closePro(); skip(); } : null;
    proBox.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); if (okOnly) setTimeout(closePro, 1600);
  }
  function closePro() { proBox.hidden = true; }
  $('[data-cv-proclose]').addEventListener('click', closePro);
  $('[data-cv-unlock]').addEventListener('click', function () { tryCode(codeIn.value).then(function (ok) { if (ok && after) { var f = after; after = null; f(); } }); });
  codeIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); $('[data-cv-unlock]').click(); } });

  // ------------------------------------------------------------ ui
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function mb(n) { return (n / 1048576).toFixed(1) + ' MB'; }
  function renderList() {
    list.innerHTML = files.map(function (f, i) {
      return '<li class="cv-item' + (f.state === 'done' ? ' is-done' : f.state === 'err' ? ' is-err' : '') + '"><span class="cv-n">' + esc(f.file.name) + '</span><span class="cv-s">' + esc(f.msg || mb(f.file.size)) + '</span>' +
        (busy ? '' : '<button type="button" class="cv-x" data-cv-rm="' + i + '" aria-label="x">×</button>') + '</li>';
    }).join('');
    panel.hidden = !files.length; drop.classList.toggle('is-loaded', files.length > 0);
    goBtn.textContent = files.length > 1 ? T.gon.replace('{n}', files.length) : T.go;
    goBtn.disabled = busy || !files.length;
  }
  function ui() {
    $$('[data-cv-fmt]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cv-fmt') === fmt ? 'true' : 'false'); });
    $$('[data-cv-q]').forEach(function (b) { var p = b.getAttribute('data-cv-q').split(':'); b.hidden = p[0] !== fmt; b.setAttribute('aria-pressed', q[p[0]] === p[1] ? 'true' : 'false'); });
    $$('[data-cv-rate]').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-cv-rate') === rate ? 'true' : 'false'); });
    $$('[data-cv-ex]').forEach(function (b) { b.setAttribute('aria-pressed', ex[b.getAttribute('data-cv-ex')] ? 'true' : 'false'); });
    $('[data-cv-tags]').hidden = !ex.tags;
    renderList();
  }
  function add(fl) {
    Array.prototype.forEach.call(fl, function (f) {
      if (!/^audio\//.test(f.type) && !/\.(wav|mp3|m4a|aac|flac|ogg|oga|opus|aif|aiff|webm|mp4|caf)$/i.test(f.name)) return;
      files.push({ file: f, state: f.size > 150 * 1048576 ? 'err' : 'new', msg: f.size > 150 * 1048576 ? T.big : '' });
    });
    status.textContent = ''; ui();
  }
  fileIn.addEventListener('change', function () { add(fileIn.files); fileIn.value = ''; });
  ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); }); });
  ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); }); });
  drop.addEventListener('drop', function (e) { if (e.dataTransfer.files.length) add(e.dataTransfer.files); });
  list.addEventListener('click', function (e) { var b = e.target.closest('[data-cv-rm]'); if (b && !busy) { files.splice(+b.getAttribute('data-cv-rm'), 1); ui(); } });
  $$('[data-cv-fmt]').forEach(function (b) { b.addEventListener('click', function () { fmt = b.getAttribute('data-cv-fmt'); ui(); }); });
  $$('[data-cv-q]').forEach(function (b) { b.addEventListener('click', function () { var p = b.getAttribute('data-cv-q').split(':'); q[p[0]] = p[1]; ui(); }); });
  $$('[data-cv-rate]').forEach(function (b) { b.addEventListener('click', function () { rate = +b.getAttribute('data-cv-rate'); ui(); }); });
  $$('[data-cv-ex]').forEach(function (b) { b.addEventListener('click', function () { var k = b.getAttribute('data-cv-ex'); ex[k] = !ex[k]; ui(); }); });
  $('[data-cv-cover]').addEventListener('change', function (e) {
    var f = e.target.files[0]; if (!f) return;
    var img = new Image();
    img.onload = function () {
      var s = Math.min(1, 800 / Math.max(img.width, img.height)), c = document.createElement('canvas'); c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      c.toBlob(function (b) { b.arrayBuffer().then(function (ab) { cover = { data: new Uint8Array(ab), w: c.width, h: c.height }; $('[data-cv-covername]').textContent = f.name; }); }, 'image/jpeg', 0.88);
    };
    img.src = URL.createObjectURL(f);
  });

  // ------------------------------------------------------------ convert
  var lameP = null;
  function loadLame() {
    if (window.lamejs) return Promise.resolve(); if (lameP) return lameP;
    lameP = new Promise(function (res, rej) { var s = document.createElement('script'); s.src = LAME; s.onload = res; s.onerror = function () { lameP = null; rej(); }; document.head.appendChild(s); });
    return lameP;
  }
  function tick() { return new Promise(function (r) { setTimeout(r, 0); }); }
  function decode(file, sr) {
    return file.arrayBuffer().then(function (ab) {
      var oc = new OfflineAudioContext(2, 1, sr);
      return new Promise(function (res, rej) { oc.decodeAudioData(ab, res, rej); });
    });
  }
  function mp3(chs, sr, kbps, onp) {
    return loadLame().then(function () {
      return new Promise(function (res) {
        var nc = chs.length, enc = new lamejs.Mp3Encoder(nc, sr, kbps), parts = [], blk = 1152 * 40, i = 0, l = chs[0], r = chs[nc - 1], g = NAUDIO.peakGain(chs, 0.999);
        var L16 = new Int16Array(blk), R16 = new Int16Array(blk);
        function step() {
          var t0 = Date.now();
          while (i < l.length && Date.now() - t0 < 40) {
            var n = Math.min(blk, l.length - i);
            for (var k = 0; k < n; k++) { var a = l[i + k] * g, c = r[i + k] * g; a = a > 1 ? 1 : a < -1 ? -1 : a; c = c > 1 ? 1 : c < -1 ? -1 : c; L16[k] = a < 0 ? a * 0x8000 : a * 0x7fff; R16[k] = c < 0 ? c * 0x8000 : c * 0x7fff; }
            var lb = n === blk ? L16 : L16.subarray(0, n), rb = n === blk ? R16 : R16.subarray(0, n);
            var out = nc === 1 ? enc.encodeBuffer(lb) : enc.encodeBuffer(lb, rb);
            if (out.length) parts.push(new Uint8Array(out)); i += n;
          }
          onp(i / l.length);
          if (i < l.length) setTimeout(step, 0); else { var e = enc.flush(); if (e.length) parts.push(new Uint8Array(e)); res(NAUDIO.concat(parts)); }
        }
        step();
      });
    });
  }
  function base(name) { return name.replace(/\.[^.]+$/, ''); }
  function convertOne(item, opt) {
    item.state = 'busy'; item.msg = T.decode; renderList();
    return decode(item.file, opt.rate).then(function (buf) {
      item.msg = T.work; renderList();
      return tick().then(function () {
        var chs = []; for (var c = 0; c < buf.numberOfChannels; c++) chs.push(buf.getChannelData(c));
        var note = '';
        if (opt.trim) chs = NAUDIO.trim(chs, opt.rate);
        if (opt.loud) { var r = NAUDIO.normalize(chs, opt.rate, -14, 0.891); chs = r.chs; note = T.lufs.replace('{a}', r.before.toFixed(1)).replace('{b}', r.after.toFixed(1)); }
        item.msg = T.enc; renderList();
        var meta = opt.tags ? { title: opt.title, artist: opt.artist, cover: opt.cover ? opt.cover.data : null, coverW: opt.cover ? opt.cover.w : 0, coverH: opt.cover ? opt.cover.h : 0 } : null;
        var p;
        if (opt.fmt === 'mp3') p = mp3(chs, opt.rate, +opt.q, function (v) { item.msg = T.enc + ' ' + Math.round(v * 100) + '%'; renderList(); }).then(function (d) { return meta ? NAUDIO.concat([NAUDIO.id3(meta), d]) : d; });
        else if (opt.fmt === 'flac') p = tick().then(function () { var g = NAUDIO.peakGain(chs, 0.999); return NAUDIO.flac(g < 1 ? chs.map(function (d) { return d.map(function (x) { return x * g; }); }) : chs, opt.rate, +opt.q, meta); });
        else p = tick().then(function () { var g = NAUDIO.peakGain(chs, 0.999); return NAUDIO.wav(g < 1 ? chs.map(function (d) { return d.map(function (x) { return x * g; }); }) : chs, opt.rate, +opt.q); });
        return p.then(function (data) {
          item.state = 'done'; item.msg = T.done + ' · ' + mb(data.length) + (note ? ' · ' + note : ''); renderList();
          return { name: base(item.file.name) + '.' + opt.fmt, data: data };
        });
      });
    }).catch(function () { item.state = 'err'; item.msg = T.bad; renderList(); return null; });
  }
  function save(name, data, type) {
    var url = URL.createObjectURL(new Blob([data], { type: type })), a = document.createElement('a');
    a.href = url; a.download = name; a.className = 'cv-hidden'; root.appendChild(a); a.click();
    setTimeout(function () { a.remove(); URL.revokeObjectURL(url); }, 60000);
  }
  var TYPES = { mp3: 'audio/mpeg', wav: 'audio/wav', flac: 'audio/flac' };
  function run(useAll) {
    var opt = { fmt: fmt, q: q[fmt], rate: rate, loud: ex.loud, trim: ex.trim, tags: ex.tags, title: $('[data-cv-title]').value.trim(), artist: $('[data-cv-artist]').value.trim(), cover: cover };
    var todo = files.filter(function (f) { return f.state !== 'err'; });
    if (!useAll) { // free fallback
      if (opt.fmt === 'flac') { opt.fmt = 'wav'; opt.q = '16'; }
      if (opt.fmt === 'wav') opt.q = '16';
      opt.loud = opt.trim = opt.tags = false; todo = todo.slice(0, 1);
    }
    if (!todo.length) return;
    busy = true; renderList(); status.textContent = '';
    var out = [], chain = Promise.resolve();
    todo.forEach(function (it) { chain = chain.then(function () { return convertOne(it, opt).then(function (r) { if (r) out.push(r); }); }); });
    chain.then(function () {
      if (out.length === 1) save(out[0].name, out[0].data, TYPES[opt.fmt]);
      else if (out.length > 1) {
        status.textContent = T.zip;
        var seen = {}; out.forEach(function (o) { var n = o.name, k = 2; while (seen[n]) n = o.name.replace(/(\.[^.]+)$/, ' (' + (k++) + ')$1'); seen[n] = 1; o.name = n; });
        save('NameOnTheBeat converter.zip', NAUDIO.zip(out), 'application/zip');
      }
      status.textContent = out.length ? T.saved : '';
    }).then(function () { busy = false; renderList(); });
  }
  function needsPro() {
    var n = files.filter(function (f) { return f.state !== 'err'; }).length;
    return n > 1 || fmt === 'flac' || (fmt === 'wav' && q.wav === '24') || ex.loud || ex.trim || ex.tags;
  }
  goBtn.addEventListener('click', function () {
    if (busy || !files.length) return;
    files.forEach(function (f) { if (f.state === 'done') { f.state = 'new'; f.msg = ''; } });
    if (needsPro() && !pro) { openPro(false, function () { run(true); }, function () { run(false); }); return; }
    run(true);
  });

  proUi(); ui();
})();
